module.exports = __webpack_public_path__ + "img/lk.2dc3a39f.svg";